import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import { Box, Container, Grid, Typography } from '@mui/material';
import photo from '../assets/HeadBack.webp';
import PageBanner from './SectionPageBanner';

const ContactHero = () => {

  const contactItems = [
    { icon: PhoneIcon, label: '+91 98065876367' },
    { icon: EmailIcon, label: 'info@loopsystech.in' },
    { icon: LocationOnIcon, label: '341, MR1 Mahalaxmi Nagar, Indore, M.P. 452010' },
  ];


  return (
    <Box sx={{ bgcolor: '#fcfcfc', pt: 0, pb: { xs: 12, sm: 16 } }}>
       <PageBanner image={photo} title="Contact Us" />

      <Container maxWidth="md" sx={{ mt: 6, 
         width: {
                    xs: '95%',
                    sm: '100%',
                    md: '100%',
                    lg: '85%',
                    xl: '85%',
                }, maxWidth: 'lg'
      }}>
        <Box textAlign="center">
          <Typography
            variant="h6"
            color="#686868"
            fontFamily="Nunito"
            sx={{ maxWidth: 600, mx: 'auto', mb: 4 }}
          >
            We’re here to answer your questions, hear your ideas, and help you get started.
          </Typography>

          <Grid container spacing={3} justifyContent="center">
            {contactItems.map((item, idx) => (
              <Grid item xs={12} md={4} key={idx}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    p: 3,
                    borderRadius: 2,
                    height: '100%',
                    backgroundColor: '#f5f5f5',
                    position: 'relative',
                    overflow: 'hidden',
                    transition: 'all 0.4s ease',
                    cursor: 'pointer',

                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      width: '100%',
                      height: '0%',
                      bottom: 0,
                      left: 0,
                      backgroundColor: '#0c5ADB',
                      zIndex: 0,
                      transition: 'height 0.4s ease',
                    },

                    '&:hover::before': {
                      height: '100%',
                    },

                    '&:hover .contact-text': {
                      color: '#fff',
                    },

                    '& .contact-icon': {
                      position: 'relative',
                      zIndex: 1,
                      color: 'rgb(147, 147, 147)',
                    },

                    '& .contact-text': {
                      position: 'relative',
                      zIndex: 1,
                      fontFamily: 'Rajdhani',
                      fontWeight: 600,
                      fontSize: '20px',
                      transition: 'color 0.4s ease',
                      color: '#000',
                    },
                  }}
                >
                  <item.icon
                    fontSize="large"
                    className="contact-icon"
                    sx={{
                      color: 'red',
                      transition: 'color 0.4s ease',
                      position: 'relative',
                      zIndex: 1,
                    }}
                  />

                  <Typography className="contact-text">{item.label}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default ContactHero;
